export default app => {
  const $inject = ['$httpProvider'];

  const AuthConfig = function ($httpProvider) {
    $httpProvider.defaults.useXDomain = true;
    delete $httpProvider.defaults.headers.common['X-Requested-With'];

    $httpProvider.interceptors.push('authInterceptor');
  };

  AuthConfig.$inject = $inject;

  return AuthConfig;
};



// WEBPACK FOOTER //
// ./src/config/authConfig.js